import React from 'react';
import PropTypes from 'prop-types';

import BizCard from '../../components/UI/BizCard';

const LcsFis = (props) => (
  <BizCard title="Further Information Sheet">
    <table className="biz-form-table">
      <tbody>
        <tr>
          <td className="biz-form-table-label">Queries</td>
          <td className="biz-form-table-input">
            <table className="biz-data-table biz-bordered">
              <thead>
                <tr>
                  <th>Query</th>
                  <th>Reply</th>
                </tr>
              </thead>
              <tbody>
                {
                  props.lcsFis.queries.map((entry) => (
                    <tr key={entry.id}>
                      <td>{entry.query}</td>
                      <td>{entry.reply}</td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </BizCard>
);

LcsFis.propTypes = {
  lcsFis: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    queries: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
    })).isRequired,
  })).isRequired,
};

export default LcsFis;



// WEBPACK FOOTER //
// ./src/pages/leads/LcsFis.jsx